export const resolveMessageInboxId = inboxId => {
  return inboxId?.value ?? inboxId;
};
